const ENCalendar = {
	"Erro ao carregar os eventos":"Error loading events",
	"Evento não implementado":"Event not implemented",
	"Evento não identificado":"unidentified event",
	"Mostrar datas iniciais":"Show start dates",
	"Mostrar datas finais":"Show end dates",
	"Todos eventos":"All events",
	"Meus Eventos":"My events"
};

export default ENCalendar;
